import React from 'react';
import { Pinger, PingerProps, PingerVariant } from '../../components/pinger';
import { Button, ButtonProps, ButtonVariant } from '../../components/button';
import cn from 'clsx';
import s from './PatternPillCluster.module.css';
import { LinkerComponent } from '../../components/link-manager/LinkManager';
import { Language } from '@prismicio/client';

export type PillClusterPillInput = Pick<
    ButtonProps & PingerProps,
    'label' | 'hrefLink' | 'icon' | 'disabled' | 'onClick' | 'target'
> & {
    active?: boolean;
    inactive?: boolean;
    componentType?: 'button' | 'pinger';
    buttonVariant?: ButtonVariant;
    pingerVariant?: PingerVariant;
};

type PillCusterProps = {
    cluster: PillClusterPillInput[];
    nowrap?: boolean;
    lang: string;
    Linker?: LinkerComponent;
};

export const PatternPillCluster = ({
    cluster,
    nowrap,
    lang,
    Linker,
}: PillCusterProps) => {
    const rootClassName = cn(s.root, {
        [s.noWrap]: nowrap,
    });
    return (
        <div className={rootClassName}>
            {cluster.map((pill, key) => {
                const {
                    label,
                    hrefLink,
                    icon,
                    active,
                    disabled,
                    inactive,
                    onClick,
                    componentType = 'pinger',
                    buttonVariant,
                    pingerVariant,
                } = pill;

                const effectiveButtonVariant =
                    buttonVariant || (active ? 'active' : 'secondary');

                const effectivePingerVariant =
                    pingerVariant || (active ? 'active' : 'base');

                return componentType === 'pinger' ? (
                    <Pinger
                        variant={effectivePingerVariant}
                        radiusSize="large"
                        hrefLink={hrefLink}
                        label={label}
                        icon={icon}
                        disabled={disabled}
                        inactive={inactive}
                        onClick={onClick}
                        key={key}
                        Linker={Linker}
                        lang={lang}
                    />
                ) : (
                    <Button
                        variant={effectiveButtonVariant}
                        radiusSize="large"
                        hrefLink={hrefLink}
                        label={label}
                        icon={icon}
                        disabled={disabled}
                        inactive={inactive}
                        onClick={onClick}
                        key={key}
                        Linker={Linker}
                        lang={lang}
                    />
                );
            })}
        </div>
    );
};

export default PatternPillCluster;
